import Grid2 from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';

export const MIN_PASS_LENGTH = 8;

export const AccountCreationFields = ({
  password,
  setPassword,
  repeatPassword,
  setRepeatPassword,
  disabled,
}: {
  password: string;
  setPassword: (val: string) => void;
  repeatPassword: string;
  setRepeatPassword: (val: string) => void;
  disabled?: boolean;
}) => (
  <>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField
        size="small"
        label="Hasło"
        type="password"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={password !== '' && password.length < MIN_PASS_LENGTH}
        helperText={
          password !== '' && password.length < MIN_PASS_LENGTH ? `Minimalna długość hasła to ${MIN_PASS_LENGTH} znaków.` : ''
        }
        required
        disabled={disabled}
      />
    </Grid2>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField
        size="small"
        label="Powtórz hasło"
        type="password"
        fullWidth
        value={repeatPassword}
        onChange={(e) => setRepeatPassword(e.target.value)}
        error={repeatPassword !== '' && password !== repeatPassword}
        helperText={repeatPassword !== '' && password !== repeatPassword ? 'Hasła muszą być takie same.' : ''}
        required
        disabled={disabled}
      />
    </Grid2>
  </>
);
